import React from 'react';
import PropTypes from 'prop-types';

import { BaseButton } from '../base-button';
import styles from './SimpleLargeButton.css';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const SimpleLargeButton = props => (
  <BaseButton
    {...props}
    className={[props.className, styles.container].join(' ')}
    pressedClassName={styles.pressed}
    disabledClassName={styles.disabled}
  />
);

SimpleLargeButton.propTypes = IPropTypes;
SimpleLargeButton.defaultProps = defaultProps;

export { SimpleLargeButton };



// WEBPACK FOOTER //
// ./src/common/simple-large-button/SimpleLargeButton.jsx